import { useParams } from 'react-router-dom';
import { DatasetStatus } from '~/api/types';
import { useGetDatasetQuery } from '~/api/v2/hooks';

const useHasLockedStatus = () => {
  const datasetId = +useParams().id!;
  const { data } = useGetDatasetQuery({ datasetId }, { skip: !datasetId });

  return {
    // "DB" datasets (SMUS Glue tables) keep metadata editable in Locked statuses (backend sets details_edit_allowed)
    hasLockedStatus: data?.status
      ? [DatasetStatus.LOCKED_RESTRICTED, DatasetStatus.LOCKED_SEARCHABLE].includes(data.status) &&
        data.status_edit_allowed &&
        !data.details_edit_allowed
      : false,
  };
};

export default useHasLockedStatus;
